import _ from '@lodash';
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import * as Actions from '../Store/Actions/MinhasTarefasActions';
import AtendimentoDialog from './Atendimento/AtendimentoDialog';
import CheckoutDialog from "./CheckoutDialog";
import FluxoErrorDialog from './FluxoErrorDialog';
import IniciarTarefaDialog from './IniciarTarefaDialog';
import MinhasTarefasDialog from './MinhasTarefasDialog';

class DialogFactory extends XAPPComponent {

    getDialog = () => {
        const { jsonpasso, passofluxo, data } = this.props.minhatarefa;
        const { listFilter, getFiltro, parametros } = this.props;

        switch (jsonpasso.formulario) {
            case "IniciarTarefaDialog":
                return (
                    <IniciarTarefaDialog
                        xappRouteParams={this.props.xappRouteParams}
                        openDialog={this.props.clearMinhaTarefa}
                        open={this.props.minhatarefa}
                        listFilter={listFilter}
                        getFiltro={getFiltro}
                        parametros={parametros}
                        readOnly={jsonpasso.readonly}
                    />
                );
            case "AtendimentoDialog":
                return (
                    <AtendimentoDialog
                        xappRouteParams={this.props.xappRouteParams}
                        openDialog={this.props.clearMinhaTarefa}
                        open={this.props.minhatarefa}
                        listFilter={listFilter}
                        getFiltro={getFiltro}
                        parametros={parametros}
                        readOnly={jsonpasso.readonly}
                    />
                );
            case "CheckoutDialog":
                return (
                    <CheckoutDialog
                        xappRouteParams={this.props.xappRouteParams}
                        openDialog={this.props.clearMinhaTarefa}
                        open={this.props.minhatarefa}
                        listFilter={listFilter}
                        getFiltro={getFiltro}
                        parametros={parametros}
                        readOnly={jsonpasso.readonly}
                    />
                );
            default:
                return (
                    <MinhasTarefasDialog
                        xappRouteParams={this.props.xappRouteParams}
                        openDialog={this.props.clearMinhaTarefa}
                        open={this.props.minhatarefa}
                        listFilter={listFilter}
                        getFiltro={getFiltro}
                        parametros={parametros}
                        readOnly={jsonpasso.readonly}
                        data={data}
                    />
                );
        }
    }

    render() {
        const { open } = this.props;
        return (
            <React.Fragment>
                {open !== null && this.getDialog()}
            </React.Fragment>

        );
    }
};


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        clearMinhaTarefa: Actions.clearMinhaTarefa,
    }, dispatch);
}

function mapStateToProps({ MinhasTarefas }) {
    return {
        minhatarefa: MinhasTarefas.MinhasTarefasReducer.minhatarefa,
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DialogFactory));